// @flow

import React from "react";
import { localize } from "redux-i18n";

import actionCreators from "@modules/service/actionCreator";
import type { StepProps } from "@components";
import { HierarchyScopeForm } from "@modules/service/components/hierarchy-scope";
import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";
import type { HierarchyAssignment } from "@modules/service/types";

type OwnProps = $Exact<{
  editing: boolean,
  hierarchy: HierarchyTree,
  assignments: Array<HierarchyAssignment>,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...StepProps,
  ...PropsFromLocalize,
}>;

export class StepHierarchyScope extends React.Component<Props> {
  handleChanges = (data: Array<HierarchyAssignment>) => {
    this.props.onChange({ assignments: data }, true);
  };
  get data() {
    return this.props.data;
  }
  render() {
    if (!this.props.editable) {
      return <div />;
    }

    return (
      <div className="w-100 d-flex justify-content-center">
        <div className="col-sm-12">
          <HierarchyScopeForm
            hierarchy={this.props.hierarchy}
            assignments={this.props.assignments}
            onChange={this.handleChanges}
          />
        </div>
      </div>
    );
  }
}

export default localize()(StepHierarchyScope);
